import BotaoLotacoes from '../components/BotaoLotacoes';
import Links from '@/shared/constants/navegacao';
import { labelVisaoUsuario } from '@/shared/constants/visao-sistema.constants';
import { ColaboradorEnum, ColaboradorList } from '../../enums/tipo-vinculo.enum';
import { Column } from '@/shared/components/tables/DataTable';
import { Link } from 'react-router-dom';
import { ReadPersonDto } from '@/api.types';
import { convertToGMTPlus3, DataAmigavel } from '@/shared/utils/datas';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale/pt-BR';
import { validaCPF } from '@/shared/utils/cpfs';

// Colunas Visão Geral.
export const colunasGeral: Column<ReadPersonDto>[] = [
  { key: "cpf", header: "CPF", render: (row) => validaCPF(row.cpf!, true), invisible: true },
  {
    key: "nome", header: "Nome Completo",
    render: (row) => (<>{row.nome}</>)
  },
  {
    key: "dataNascimento",
    header: "Aniversário",
    type: "date",
    invisible: true,
    render: (row) =>
      row.dataNascimento ? format(new Date(row.dataNascimento), "dd/MM/yyyy", { locale: ptBR }) : ''
  },
  { key: "email", header: "E-mail", invisible: true },
  { key: "emailInstitucional", header: "E-mail Institucional", invisible: true },
  { key: "telefone.numero", header: "Telefone", invisible: true },
  { key: "celular.numero", header: "Celular", invisible: true },
  {
    key: "defensor", header: "Defensor?", invisible: true, render: (row) => {
      if (!row.defensor) return '-';
      return row.defensor.ativo === false ? 'SIM (inativo)' : 'SIM';
    }
  },
  {
    key: "estagiario", header: "Estagiário?", invisible: true, render: (row) => {
      if (!row.estagiario) return '-';
      return row.estagiario.ativo === false ? 'SIM (inativo)' : 'SIM';
    }
  },
  { key: "usuario", header: "Usuário?", invisible: true, render: (row) => <>{row.usuario ? 'SIM' : '-'}</> },
  {
    key: "acoes", header: "Ações",
    render: (row) =>
      <Link className="link-secondary" to={Links.Pessoa_Editar + '/' + row.id}>
        Editar
      </Link>
  },
];

// Colunas Defensor.
export const colunasDefensor: Column<ReadPersonDto>[] = [
  {
    key: "nome", header: "Nome Completo",
    render: (row) =>
      row.defensor?.ativo
        ? row.nome
        : <span className="text-muted">{row.nome} (inativo)</span>
  },
  {
    key: "emailInstitucional",
    header: "E-mail Institucional",
    invisible: true,
  },
  {
    key: "dataNascimento",
    header: "Nascimento",
    type: "date",
    invisible: true,
    render: (row) =>
      row.dataNascimento ? format(new Date(row.dataNascimento), "dd/MM/yyyy", { locale: ptBR }) : ''
  },
  {
    key: "defensor.data_admissao",
    header: "Admissão",
    type: "date",
    render: (row) =>
      row.defensor?.data_admissao
        ? format(new Date(convertToGMTPlus3(row.defensor.data_admissao)), "dd/MM/yyyy", { locale: ptBR })
        : ''
  },
  {
    key: "defensor.data_referencia",
    header: "Referência",
    type: "date",
    render: (row) =>
      row.defensor?.data_referencia
        ? format(new Date(convertToGMTPlus3(row.defensor.data_referencia)), "dd/MM/yyyy", { locale: ptBR })
        : ''
  },
  {
    key: "defensor.data_exoneracao",
    header: "Exoneração",
    type: "date",
    render: (row) =>
      row.defensor?.data_exoneracao
        ? format(new Date(convertToGMTPlus3(row.defensor.data_exoneracao)), "dd/MM/yyyy", { locale: ptBR })
        : ''
  },
  {
    key: "lotacoes", header: "Lotações",
    render: (row) =>
      row.defensor?.id ? (
        <BotaoLotacoes
          tipoPessoa="defensor"
          pessoaId={row.defensor.id}
          pessoaNome={row.nome}
        />
      ) : null
  },
  {
    key: "timeline", header: "Linha do Tempo",
    render: (row) =>
      <>
        {row.defensor &&
          <Link className="link-secondary" to={`${Links.Defensor_Timeline}?id=${row.defensor?.id}`}>
            Linha do Tempo
          </Link>}
      </>
  },
  {
    key: "acoes", header: "Ações",
    render: (row) =>
      <Link className="link-secondary" to={`${Links.Pessoa_Editar}/${row.id}`}>
        Editar
      </Link>
  },
];

// Colunas Estagiários.
export const colunasEstagiarios: Column<ReadPersonDto>[] = [
  { key: "cpf", header: "CPF", render: (row) => validaCPF(row.cpf!, true), invisible: true },
  {
    key: "dataNascimento",
    header: "Aniversário",
    type: "date",
    invisible: true,
    render: (row) =>
      row.dataNascimento ? format(new Date(row.dataNascimento), "dd/MM/yyyy", { locale: ptBR }) : ''
  },
  {
    key: "nome", header: "Nome Completo",
    render: (row) =>
      row.estagiario?.ativo
        ? row.nome
        : <span className="text-muted">{row.nome} (inativo)</span>
  },
  {
    key: "estagiario.estagios.data_inicio_estagio",
    header: "Início do Estágio",
    type: "date",
    render: (row) =>
      row.estagiario?.estagios?.[0]?.data_inicio_estagio
        ? DataAmigavel(row.estagiario.estagios[0].data_inicio_estagio)
        : "N/A"
  },
  {
    key: "estagiario.estagios.data_fim_estagio",
    header: "Fim do Estágio",
    type: "date",
    render: (row) =>
      row.estagiario?.estagios?.[0]?.data_fim_estagio
        ? DataAmigavel(row.estagiario.estagios[0].data_fim_estagio)
        : "N/A"
  },
  {
    key: "estagiario.estagios.desligamento",
    header: "Desligamento",
    type: "date",
    render: (row) =>
      row.estagiario?.estagios?.[0]?.desligamento
        ? DataAmigavel(row.estagiario.estagios[0].desligamento)
        : "-"
  },
  { key: "email", header: "E-mail", invisible: true },
  { key: "emailInstitucional", header: "E-mail Institucional", invisible: true },
  { key: "estagiario.estagios.0.email", header: "E-mail Estágio", invisible: true },
  {
    key: "lotacoes", header: "Lotações",
    render: (row) =>
      row.estagiario?.id ? (
        <BotaoLotacoes
          tipoPessoa="estagiario"
          pessoaId={row.estagiario.id}
          pessoaNome={row.nome}
        />
      ) : null
  },
  {
    key: "acoes", header: "Ações",
    render: (row) =>
      <Link className="link-secondary" to={`${Links.Pessoa_Editar}/${row.id}`}>
        Editar
      </Link>
  },
];

// Colunas Usuários.
export const colunasUsuarios: Column<ReadPersonDto>[] = [
  {
    key: "nome", header: "Nome Completo",
    render: (row) => {
      const n = row.nome;
      return (
        <>
          {row.usuario?.ativo ? n : <span className="text-muted">{n}{row.usuario?.ativo ? '' : ' (inativo)'}</span>}
        </>
      )
    }
  },
  {
    key: "usuario.visao",
    header: "Visão",
    render: (row) => labelVisaoUsuario((row.usuario as { visao?: number | null } | undefined)?.visao),
  },
  {
    key: "usuario.recebenotificacoes", header: "Notificações",
    render: (row) => (
      <input
        title="Recebe notificações"
        type="checkbox"
        checked={Boolean(row.usuario?.recebenotificacoes)}
        readOnly
      />
    ),
  },
  {
    key: "acoes", header: "Ações", render: (row) =>
      <Link className="link-secondary" to={`${Links.Pessoa_Editar}/${row.id}`}>
        Editar
      </Link>
  },
];


// Colunas Colaborador.
export const colunasColaboradores: Column<ReadPersonDto>[] = [
  { key: "cpf", header: "CPF", render: (row) => validaCPF(row.cpf!, true), invisible: true },
  {
    key: "nome", header: "Nome Completo",
    render: (row) => (<>{row.nome}</>)
  },
  { key: "colaborador.funcao_nome", header: "Função", render: (row) => <>{row.colaborador?.funcao?.nome}</> },
  { key: "colaborador.matricula", header: "Matrícula", render: (row) => <>{row.colaborador?.matricula}</> },
  { key: "colaborador.orgao_origem", header: "Orgão Origem", invisible: false, render: (row) => <>{row.colaborador?.orgao_origem}</> },
  {
    key: "dataNascimento",
    header: "Aniversário",
    type: "date",
    invisible: true,
    render: (row) =>
      row.dataNascimento ? format(new Date(row.dataNascimento), "dd/MM/yyyy", { locale: ptBR }) : ''
  },
  { key: "email", header: "E-mail", invisible: true },
  { key: "emailInstitucional", header: "E-mail Institucional", invisible: true },
  { key: "telefone.numero", header: "Telefone", invisible: true },
  { key: "celular.numero", header: "Celular", invisible: true },
  {
    key: "colaborador.tipo_vinculo",
    header: "Tipo de Vínculo",
    invisible: false,
    render: (row) => {
      const tipoVinculo = ColaboradorList.find(a => a.value == row.colaborador?.tipo_vinculo)?.name || '-';
      const vinculoDireto = row.colaborador?.vinculo_direto;
      const cessaoOnerosa = row.colaborador?.cessao_onerosa;

      return (
        <>
          {tipoVinculo}
          {vinculoDireto && (
            <>
              <br />
              (vínculo direto)
            </>
          )}
          {cessaoOnerosa && (
            <>
              <br />
              (cessão onerosa)
            </>
          )}
          {!cessaoOnerosa && !vinculoDireto && row.colaborador?.tipo_vinculo === ColaboradorEnum.cedido && (
            <>
              <br />
              (cessão não onerosa)
            </>
          )}
        </>
      );
    }
  },
  {
    key: "colaborador.data_cessao", header: "Data Cessão",
    invisible: false,
    type: "date",
    render: (row) =>
      row.colaborador?.data_cessao
        ? format(new Date(row.colaborador?.data_cessao), "dd/MM/yyyy", { locale: ptBR })
        : ''
  },
  {
    key: "colaborador.data_saida", header: "Data Saída",
    invisible: false,
    render: (row) =>
      row.colaborador?.data_saida
        ? format(new Date(row.colaborador?.data_saida), "dd/MM/yyyy", { locale: ptBR })
        : ''
  },
  {
    key: "lotacoes", header: "Lotações",
    render: (row) =>
      row.colaborador?.id ? (
        <BotaoLotacoes
          tipoPessoa="colaborador"
          pessoaId={row.colaborador.id}
          pessoaNome={row.nome}
        />
      ) : null
  },
  {
    key: "acoes", header: "Ações",
    render: (row) =>
      <Link className="link-secondary" to={`${Links.Pessoa_Editar}/${row.id}`}>
        Editar
      </Link>
  },
];